interface ChatOpsMessageHandlerParams {
	event: MessageEvent;
	onSuccessCallback: () => void;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onFailedCallback?: (errorCode: any) => void;
	requiredEventId: string;
}

export const EVENT_ORIGINS = [
	'https://api-private.stg.atlassian.com',
	'https://api-private.atlassian.com',
];

export const chatOpsMessageHandler = ({
	event,
	onSuccessCallback,
	onFailedCallback,
	requiredEventId,
}: ChatOpsMessageHandlerParams) => {
	if (!EVENT_ORIGINS.includes(event.origin)) {
		return;
	}

	if (
		!event.data ||
		!event.data.event_id ||
		!event.data.data ||
		event.data.event_id !== requiredEventId
	) {
		return;
	}

	const eventData = event.data;

	if (eventData?.data?.success === 'true') {
		onSuccessCallback();
	} else if (eventData?.data?.success === 'false') {
		onFailedCallback?.(eventData.data.error);
	}
};
